module.exports = __webpack_public_path__ + "img/DealerIcons-Instagram-Off.b0f61a7.jpg";